/**
 * A drop's senders on the Day timeline (user, 22/10/2026: "add Gateway
 * Senders Texts info so you can see the full picture"): the draft's sender
 * names once written; before that, muted, its lane's own IDs — or "AI names"
 * when the AI writes them at generation. Every name behind the tooltip.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Tooltip } from '@/components/ui';
import { cn } from '@/lib/utils';

import type { DayPlanDropRow } from '../../../drop-generator.types';

const Dash = () => <span className="text-xs text-muted-foreground">—</span>;

export const SendersCell: FC<{ drop: DayPlanDropRow }> = ({ drop }) => {
  const written = drop.runtime?.senders ?? null;
  const planned = drop.senderIds ?? null;
  const names = written && written.length > 0 ? written : planned;
  if (names === null) return <Dash />;
  const final = names === written;
  if (names.length === 0)
    return (
      <Tooltip content="The AI writes this drop's sender names at generation.">
        <span className="block truncate text-xs text-muted-foreground">AI names</span>
      </Tooltip>
    );
  const tip = (
    <span className="flex flex-col gap-0.5">
      <span className="text-muted-foreground">{final ? 'Sender names of the draft' : "The lane's sender IDs — the draft gets its names at generation"}</span>
      {names.map((n) => (
        <span key={n} className="font-mono">{n}</span>
      ))}
    </span>
  );
  return (
    <Tooltip content={tip}>
      <span className={cn('block truncate font-mono text-xs', !final && 'text-muted-foreground')} data-testid="drop-senders">
        {names[0]}
        {names.length > 1 ? <span className="text-muted-foreground"> +{names.length - 1}</span> : null}
      </span>
    </Tooltip>
  );
};
